import { useEffect } from 'react';

// Shared auto-refresh for analytics pages: refetch on an interval while the tab
// is visible, and immediately when the operator returns to the tab (either by
// re-focusing the window or switching back to this browser tab). `refresh`
// should be a stable callback (wrap the loader in useCallback).
export function useAnalyticsAutoRefresh(refresh: () => void, intervalMs = 30000) {
  useEffect(() => {
    const interval = window.setInterval(() => {
      if (document.visibilityState === 'visible') {
        refresh();
      }
    }, intervalMs);
    const onFocus = () => refresh();
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        refresh();
      }
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [refresh, intervalMs]);
}
